import React from "react"
import { DIALOG_OPERATION_FEEDBACK_FORM_CONST } from "../../DialogOperatorFeedbackForm.const"
import { useTranslation } from "react-i18next"
import styles from "./FeedbackFormErrorView.module.scss"
import { ReactComponent as RobotSadIcon } from "../../../../../assets/images/feedback-form/robot-sad.svg"

export type FeedbackFormErrorViewProps = {
    onRetrySubmit: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const { tNamespace, tPaths, testIds } = DIALOG_OPERATION_FEEDBACK_FORM_CONST

const FeedbackFormErrorView = (props: FeedbackFormErrorViewProps) => {
    const { t } = useTranslation(tNamespace)
    const { onRetrySubmit } = props

    return (
        <div className={styles.error}>
            <div className={styles.error__text}>{t(tPaths.errorSuggestion)}</div>
            <RobotSadIcon className={styles.error__robot} />
            <button className={styles.error__retryButton} onClick={onRetrySubmit} data-testid={testIds.retryButton}>
                {t(tPaths.retryButton)}
            </button>
        </div>
    )
}

export default FeedbackFormErrorView
